import script from "./HealthTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthTrend.vue?vue&type=script&setup=true&lang=js"

import "./HealthTrend.vue?vue&type=style&index=0&id=29dc173c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dc173c"]])

export default __exports__